import {
  Button,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Space,
  Upload,
} from 'antd';
import moment from 'moment';
import TextArea from 'antd/lib/input/TextArea';
import { Task, TaskStatus, taskStatusKorean } from '../../modules/tasks';
import { UploadOutlined } from '@ant-design/icons';
import { normFile } from '../../util/utils';
import { useEffect, useState } from 'react';

const { Option } = Select;

interface TaskCreateUpdateComponentProps {
  task?: Task;
  uploadProps: any;
  memberData: any[];
  onCreate: (data: any) => void;
  onCancel: () => void;
}

function TaskCreateUpdateComponent({
  task,
  uploadProps,
  memberData,
  onCancel,
  onCreate,
}: TaskCreateUpdateComponentProps) {
  const [form] = Form.useForm();
  const [mount, setMount] = useState(true);
  let _task: any;
  const [memberList, setMemberList] = useState<any[]>();

  if (task) {
    _task = {
      ...task,
      dueDate: moment(task.dueDate, 'YYYY-MM-DD'),
    };
  } else {
    _task = {
      status: TaskStatus.WORK_REQUEST,
      dueDate: moment(),
    };
  }

  useEffect(() => {
    if (!mount) return;
    let children: any = [];
    for (const member of memberData) {
      children.push(
        <Option key={member.id} value={member.id}>
          {member.name}
        </Option>,
      );
    }
    setMemberList(children);
    return () => setMount(false);
  }, [memberData, mount]);

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        onFinish={onCreate}
        initialValues={_task}
      >
        <Form.Item
          name="name"
          label="제목"
          rules={[
            {
              required: true,
              message: '제목을 입력하세요.',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="status"
          label="상태"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select
            allowClear
            placeholder="상태를 선택 하세요."
            disabled={!!task}
          >
            <Option value="0">{taskStatusKorean['0']}</Option>
            <Option value="1">{taskStatusKorean['1']}</Option>
            <Option value="2">{taskStatusKorean['2']}</Option>
            <Option value="3">{taskStatusKorean['3']}</Option>
          </Select>
        </Form.Item>
        <Form.Item
          name={['assignee', 'id']}
          label="담당자"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select style={{ width: '100%' }}>{memberList}</Select>
        </Form.Item>
        <Form.Item
          name="dueDate"
          label="마감일"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item name="description" label="내용">
          <TextArea rows={4} />
        </Form.Item>

        <Form.Item
          name="file"
          label="첨부파일"
          valuePropName="fileList"
          getValueFromEvent={normFile}
        >
          <Upload {...uploadProps}>
            <Button icon={<UploadOutlined rev={undefined} />}>
              첨부파일 올리기
            </Button>
          </Upload>
        </Form.Item>

        <Row justify="center">
          <Form.Item>
            <Space size="middle">
              <Button htmlType="button" onClick={onCancel}>
                취소
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: '100px' }}
              >
                확인
              </Button>
            </Space>
          </Form.Item>
        </Row>
      </Form>
    </>
  );
}

export default TaskCreateUpdateComponent;
